export default __webpack_public_path__ + "static/media/blog_detail4.4f370d17.webp";